import React, { useContext } from 'react'
import { LoadingContext } from '../M_Utils'
import PropTypes from 'prop-types'

export function MFieldset({ label, elements, fieldColor, labelColor, labelInside, headerElement, width }) {
    const ctx = useContext(LoadingContext)

    fieldColor = fieldColor || ctx.primaryColor || 'var(--color-black)'
    labelColor = labelColor || ctx.secondaryColor || 'var(--color-black)'

    return (
        <>
            {
                labelInside ?
                    <div style={{ padding: '5px', margin: '10px', boxShadow: `1px 1px 2px ${labelColor}`, border: ` 1px solid ${fieldColor}`, borderRadius: '5px', backgroundColor: "var(--color-white)", width: width || 'auto' }}>
                        {label || headerElement ?
                            <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', }}>
                                <h3 style={{ marginLeft: '10px', marginTop: '10px', marginRight: '10px', color: labelColor }}>{label}</h3>
                                <div style={{ margin: '10px 0px 0px 10px', display: 'flex', justifyContent: 'flex-end' }}>
                                    {headerElement}
                                </div>
                            </div>
                            : ''
                        }
                        <div style={{ margin: '10px' }}>
                            {elements}
                        </div>
                    </div> :
                    <fieldset style={{ border: `1px solid ${fieldColor}`, borderRadius: '5px', padding: '10px', margin: '10px', width: width || 'auto' }}>
                        {label && <legend style={{ fontWeight: 'bold', color: labelColor }}>{label}</legend>}
                        {elements}
                    </fieldset>
            }
        </>
    )
}

MFieldset.propTypes = {
    label: PropTypes.string,
    elements: PropTypes.node,
    fieldColor: PropTypes.string,
    labelColor: PropTypes.string,
    labelInside: PropTypes.bool,
    headerElement: PropTypes.element,
    width: PropTypes.string
}